
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import * as n from "@/types/notifications";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: { Icon }
})
export default class ErrorMessage extends Vue {
  @Prop()
  value!: n.MessageNotification;

  clear() {
    this.$emit("clear");
  }
}
